export const TASK_MASTER_COLUMNS = [
    "title", 
    "project_type",
    "project_category",
    "weight", 
    "sub_tasks", 
    "actions"
];

export const TASK_MASTER_LABELS = {
  title: "Title",
  project_type: "Type",
  project_category: "Category",
  weight: "Weight",
  sub_tasks: "Sub Tasks",
  actions: "Actions"
};

export const SUB_TASK_COLUMNS = [
    "title", 
    "weight",
    "sub_tasks",
    "actions"
];

export const SUB_TASK_LABELS = {
  title: "Title",
  weight: "Weight",
  sub_tasks: "Sub Tasks",
  actions: "Actions"
};

export const MAIN_TASKS_COLUMN_WIDTHS = {
  title: "w-36",
  project_type: "w-28",
  project_category: "w-28",
  weight: "w-24",
  sub_tasks: "w-24",
  actions: "w-36",
}

export const SUB_TASKS_COLUMN_WIDTHS = {
  title: "w-36",
  weight: "w-28",
  sub_tasks: "w-28",
  actions: "w-40",
}